import { TextSpan } from '../../../Atoms/Text';
import { dollars } from './currentSupplierSpend';
import { AdviseCurrentSupplier } from '../../../../types/advise';

/** The supplier's monthly amount as upstack_api calculated it, or "Not included yet" until its entry is finished. */
export const SupplierMonthlyAmount = ({ supplier }: { supplier: AdviseCurrentSupplier }) =>
  supplier.complete ? (
    <span className="flex items-baseline gap-1">
      <TextSpan
        size="sm14"
        weight="semibold"
        color="grey8">
        {dollars(supplier.monthly_amount)}
      </TextSpan>
      <TextSpan
        size="xs"
        color="grey6">
        /mo
      </TextSpan>
    </span>
  ) : (
    <TextSpan
      size="sm"
      weight="medium"
      color="amber">
      Not included yet
    </TextSpan>
  );
